import { Lock, Plug } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { Stack } from '@/components/ui/stack';
import { usePermissions } from '@/lib/auth/usePermissions';
import { AgroHistoryStatusBoard } from './AgroHistoryStatusBoard';
import { ComingSoonTab } from './ComingSoonTab';

/**
 * Вкладка «Интеграции» настроек компании (AK-738).
 *
 * Сверху — реальный статус-борд синхронизации AgroHistory (какие сущности
 * и когда последний раз синхронизировались). Ниже — заглушка на будущие
 * интеграции (1С, Bitrix24), которых пока нет в коде.
 *
 * Гейт `company_settings:R` (парная правка к бэкенд-блокеру 2, head-backend
 * review PR #887): борд отдаёт сырой текст исключения прогона и
 * тенант-широкие счётчики — не нейтральные данные. Гейтим ПРОАКТИВНО через
 * `usePermissions()` (кэш `/me`, тот же источник, что и у бэкенда), а не
 * «толкай и жди 403» — урок AK-645, тот же паттерн, что у `RolesPanel`
 * (`useCan`/матрица прав перед рендером, не реакция на упавший запрос).
 * Без права борд НЕ монтируется вовсе — запрос к `/integrations/agrohistory/status`
 * не уходит.
 */
export function IntegrationsTab() {
  const { can, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <Stack gap={4}>
        <Skeleton className="h-40 w-full" />
      </Stack>
    );
  }

  if (!can('company_settings', 'r')) {
    return (
      <Alert variant="destructive">
        <Lock className="h-4 w-4" />
        <AlertDescription>
          Раздел «Интеграции» доступен только администратору компании.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Stack gap={4}>
      <AgroHistoryStatusBoard />
      <ComingSoonTab
        icon={Plug}
        title="Другие интеграции"
        description="1С, Bitrix24 и обмен данными с другими системами — подключение появится здесь."
      />
    </Stack>
  );
}

export default IntegrationsTab;
